import { useToast } from '@ims/ui'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { updatedSinceLastRun } from '../lib/whats-new.ts'
import { useWhatsNew } from '../screens/whats-new.tsx'

/** One toast after this device moves to a newer release (board WhatsNewWays, c). Renders nothing. */
export function WhatsNewToast() {
  const { newest } = useWhatsNew()
  const toast = useToast()
  const navigate = useNavigate()
  const id = newest?.id
  const title = newest?.title
  useEffect(() => {
    if (!id || !title || !updatedSinceLastRun(id)) return
    toast.info(`Updated to the ${title.replace(/ update$/, '')} version`, {
      label: 'See what’s new',
      onClick: () => navigate('/whats-new'),
    })
  }, [id, title, toast, navigate])
  return null
}
